var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUserLogo({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 89,
    viewBox: "0 0 80 89",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.1429 22.9215C17.1429 29.0007 19.551 34.8309 23.8376 39.1295C28.1241 43.4281 33.9379 45.8431 40 45.8431C46.0621 45.8431 51.8759 43.4281 56.1624 39.1295C60.449 34.8309 62.8571 29.0007 62.8571 22.9215C62.8571 16.8424 60.449 11.0122 56.1624 6.71356C51.8759 2.41494 46.0621 0 40 0C33.9379 0 28.1241 2.41494 23.8376 6.71356C19.551 11.0122 17.1429 16.8424 17.1429 22.9215ZM34.0179 56.0861L37.3393 61.6374L31.3929 83.8248L24.9643 57.5187C24.6071 56.0682 23.2143 55.1191 21.7679 55.4952C9.26786 58.629 0 69.9823 0 83.5024C0 86.5467 2.46429 89 5.48214 89H74.5179C77.5536 89 80 86.5288 80 83.5024C80 69.9823 70.7321 58.629 58.2321 55.4952C56.7857 55.137 55.3929 56.0861 55.0357 57.5187L48.6071 83.8248L42.6607 61.6374L45.9821 56.0861C47.125 54.17 45.75 51.7525 43.5357 51.7525H36.4821C34.2679 51.7525 32.8929 54.1879 34.0357 56.0861H34.0179Z",
    fill: "#0A3575"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserLogo);
export default __webpack_public_path__ + "static/media/UserLogo.3d9c851493a5c9904d32b3fd3ae9dd17.svg";
export { ForwardRef as ReactComponent };